import { ModalDirective } from "ng2-bootstrap/components/modal";
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from "@angular/core";
import { TranslateService } from "../../shared/translate/translate.service";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";

const $ = require("jquery");
const moment = require("moment");
const fullCalendar = require("fullcalendar");

@Component({
  selector: "wego-calander-popup",
  template: `
  <div bsModal #calanderModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" 
  aria-labelledby="mySmallModalLabel" aria-hidden="true"  [config]="{backdrop: false, keyboard: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header" style="border: 0px;padding-bottom: 0px;">
                <button type="button" class="close" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title"><strong>{{ popupTitle }}</strong></h4>    
                <h5 class="modal-title">{{ licenceTag }}</h5>  
                <h5 class="modal-title">{{ driverName }}</h5>
                <h5 class="modal-title">{{ email }}</h5>   
                <h5 class="modal-title">{{ mobileNumber }}</h5>      
              </div>      
                       
            <div class="modal-body" style="padding-top: 0px;">    
                  <div class="row">
                  <div class="col-sm-12" style="padding: 10px 10px;">
                    <div id="calendar"></div>
                  </div>
                </div>
            </div>            
        </div>
    </div>
  </div>
  <booking-info-popup #bookingInfoModel></booking-info-popup>`
})
export class CalanderPopupComponent implements OnInit, OnDestroy {
  @ViewChild("calanderModal") public confirmModal: ModalDirective;
  @ViewChild("bookingInfoModel") public bookingInfoModel: any;
  @Input("occupiedTime") occupiedTime: any;
  @Input("licenceTag") licenceTag: string;
  @Input("driverName") driverName: string;
  @Input("email") email: string;
  @Input("mobileNumber") mobileNumber: string;
  @Input("bookingReferenceId") bookingReferenceId: string;
  @Input("popupTitle") popupTitle: string;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    let LblWeekdays: any = this.translate.instant("LblWeekdays");
    let LblMonths: any = this.translate.instant("LblMonths");
    let LblButtonText: any = this.translate.instant("LblButtonText");

    $("#calendar").fullCalendar({
      header: {
        left: "prev,today,next ",
        center: "title",
        right: "month,agendaWeek,agendaDay"
      },
      displayEventEnd: {
        month: true,
        basicWeek: true,
        default: true
      },
      eventRender: (event: any, element: any) => {
        element.attr("href", "javascript:void(0);");
        element.click(() => {
          event.licenceTag = this.licenceTag;
          this.bookingInfoModel.bookingInfo = event;
          this.bookingInfoModel.show();
        });
      },
      //locale: currentLang,
      buttonText: LblButtonText,
      monthNames: LblMonths.longhand,
      monthNamesShort: LblMonths.shorthand,
      dayNames: LblWeekdays.longhand,
      dayNamesShort: LblWeekdays.shorthand,
      navLinks: true, // can click day/week names to navigate views
      editable: false,
      eventLimit: true // allow "more" link when too many events
    });
  }

  public show() {
    this.confirmModal.show();
    $("#calendar").fullCalendar("removeEvents");
    $("#calendar").fullCalendar("addEventSource", {
      events: this.occupiedTime
    });
    $("#calendar").fullCalendar("render");
    $("#calendar").fullCalendar("refetchEvents");
  }

  public hide() {
    this.confirmModal.hide();
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/calander-popup.component.ts